<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="ap.total.value" class="v3-count">{{ ap.total.value }}</span>
    </div>

    <V3Skeleton v-if="ap.isLoading.value && !ap.total.value" shape="panel" :heading="false" />
    <div v-else-if="!ap.total.value" class="v3-pstack-empty" v-testid="testid + '-empty'">
      <span class="v3-pcard-ic v3-pcard-ic--ok"><span class="ms">task_alt</span></span>
      <div class="v3-pcard-body">
        <div class="v3-pcard-title">Nothing needs a decision</div>
        <div class="v3-pcard-line">No anomalies, approvals or revisions are waiting on you right now.</div>
      </div>
    </div>

    <template v-else>
      <button v-if="ap.showAll.value" class="v3-viewall" type="button" v-testid="testid + '-show-less'" @click="ap.showAll.value = false">
        Show less
      </button>

      <div class="v3-pstack">
        <div
          v-for="c in ap.shown.value"
          :key="c.doc_id || c.reference"
          class="v3-pcard"
          :class="[`v3-pcard--${c.cardTone}`, { 'is-lead': c.lead }]"
          role="button"
          tabindex="0"
          v-testid="testid + '-row-' + (c.doc_id || c.reference)"
          @click="open(c)"
        >
          <span class="v3-pcard-ic" :class="`v3-pcard-ic--${c.cardTone}`"><span class="ms">{{ c.cardIcon }}</span></span>
          <div class="v3-pcard-id">
            <div class="v3-pcard-title">{{ c.title }}</div>
            <div v-if="c.meta" class="v3-pcard-meta">{{ c.meta }}</div>
          </div>
          <div class="v3-pcard-ctx">
            <div class="v3-pcard-state">
              <span class="v3-spill2" :class="`v3-spill2--${c.pillTone}`"><span class="ms">{{ c.pillIcon }}</span>{{ c.pillLabel }}</span>
            </div>
            <div v-if="c.context" class="v3-pcard-line">{{ c.context }}</div>
          </div>
          <div class="v3-pcard-cta">
            <button class="v3-tt-btn" :class="{ 'v3-tt-btn--lead': c.lead }" type="button" @click.stop="open(c)">
              {{ c.action }}
            </button>
          </div>
        </div>
      </div>

      <button v-if="ap.hasMore.value" class="v3-viewall" type="button" v-testid="testid + '-view-all'" @click="ap.showAll.value = !ap.showAll.value">
        {{ ap.showAll.value ? 'Show less' : 'View all (' + ap.total.value + ')' }}
      </button>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { adminPriority } from "@rm-ui/homepage/adminPriority";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) AdminPriority — thin Vue 2 presentation over the shared
// `adminPriority` composable (@rm-ui/homepage/adminPriority), backed by
// POST Report/reviewQueue. The "Needs you" priority stack of full-width
// horizontal cards. Matches the prototype V3AdminPriority. Sibling:
// rm-portal-beta AdminPriorityWidget.vue.
export default {
  name: "cLandingV3AdminPriority",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const ap = adminPriority({
      http: axios,
      getLimit: () => props.definition.limit || 3,
      getScope: () => props.definition.scope || "all",
    });
    return { ap };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3AdminPriority";
    },
    title() {
      return this.definition.title || "All Priorities (Admin View)";
    },
  },
  methods: {
    open(c) {
      if (this.editMode) return;
      const reference = c.reference || (c.row && c.row.reference);
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
